import React, { useMemo } from 'react';

import { Field } from 'react-final-form';

import Divider from 'components/shared/Divider';
import FormGroupAdapter from 'components/shared/FormAdapters/FormDefault/FormGroup';
import MapBlock from 'components/shared/MapBlock';
import FormTitle from 'components/shared/Typography/FormTitle';
import Text from 'components/shared/Typography/Text';
import { useFormFieldPopup } from 'hooks/useFormFieldPopup';
import { debounce } from 'utils/debounce';

import { useGoogleMaps } from './functions';

function GoogleMaps({ step = 'V', lat, lng, onChangeCoords, onChangeAddress }) {
  const { handleChangeAddress, handleChangeCoords, handleClickMap } = useGoogleMaps({
    onChangeCoords,
    onChangeAddress,
  });
  const coords = useMemo(() => {
    return { lat, lng };
  }, [lat, lng]);

  const showPopup = useFormFieldPopup();

  const debHandleChangeAddress = useMemo(
    () => debounce((evt) => handleChangeAddress(evt.target.value), 500),
    [handleChangeAddress],
  );

  const tooltipText = (
    <Text accent style={{ fontSize: '1.5rem' }}>
      <b>Tool Tip:</b>
      <br />
      <br />
      Please input coordinates in one of the following formats:
      <br />
      <br />
      -1.370800, 36.759700
      <br />
      1.3708 ° S, 36.7597 ° E
    </Text>
  );

  return (
    <>
      {/* "{step}. Google Maps" doesn't work. See FromTitle component */}
      <FormTitle hint="Search or add the GPS coordinates below to drop a pin.">{`${step}. Google Maps`}</FormTitle>
      <Field
        component={FormGroupAdapter}
        name="address"
        placeholder="Enter Property Name or Address"
        type="text"
        label="Location*"
        onCustomChange={debHandleChangeAddress}
        parse={(value) => value || null}
      />
      <Field
        component={FormGroupAdapter}
        name="coords"
        type="text"
        label={
          <>
            <strong>OR</strong> GPS Coordinates
          </>
        }
        placeholder="-14.235004, -51.92528"
        onCustomChange={handleChangeCoords}
        help="Enter the map coordinates for this property or drop a pin below."
        parse={(value) => value || null}
        onFocus={showPopup(tooltipText)}
      />
      {/* <Field component={FormGroupAdapter} name="page.longitude" placeholder="Longitude" type="hidden" />
      <Field component={FormGroupAdapter} name="page.latitude" placeholder="Latitude" type="hidden" /> */}
      <MapBlock coords={coords} onClickMap={handleClickMap} />
      <Divider />
    </>
  );
}

export default React.memo(GoogleMaps);
